import React from 'react'
// import Showcase from "../components/showcase";
// import Discussion from '../components/discussion'
import About from '../components/about'
import Reviews from '../components/reviews'
import Artists from '../components/artists'

export const tabs = [
  { name: 'About', component: <About />, route: 'about' },
  { name: 'Reviews', component: <Reviews />, route: 'review' },
  {name:'Artists',component:<Artists/>,route:'artists'}
  // { name: 'Discussion', component: <Discussion />, route: 'discussion' },
  // { name: "Showcase", components: <Showcase /> },
]
